import type { TextBoxColors } from 'atoms/TextBox'
import type { IContainerDescriptionProps } from './ContainerDescription'

import { styled } from '@linaria/react'
import {
  ContainerDescriptionAlignItems,
  ContainerDescriptionColumnGap,
  ContainerDescriptionDirection,
  ContainerDescriptionJustifyContent,
  ContainerDescriptionRowGap,
} from './ContainerDescription.h'

export const ContainerDescriptionStyled = styled.div<
  Omit<IContainerDescriptionProps, 'color'> & { colorDefault?: TextBoxColors }
>`
  display: flex;
  width: ${({ width, rowGap }) =>
    width ? `${width}%` : `calc(100% - var(${rowGap}))`};
  height: 100%;
  max-width: 100%;
  flex-direction: ${({ direction }) =>
    direction || ContainerDescriptionDirection.Column};
  align-items: ${({ alignItems }) =>
    alignItems || ContainerDescriptionAlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || ContainerDescriptionJustifyContent.FlexStart};
  row-gap: ${({ rowGap }) =>
    `var(${rowGap || ContainerDescriptionRowGap.INDENT_0})`};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || ContainerDescriptionColumnGap.INDENT_0})`};
  color: ${({ colorDefault }) =>
    colorDefault ? `var(${colorDefault})` : 'inherit'};
  padding: ${({ paddings }) =>
    paddings?.length
      ? paddings.map((padding) => `var(${padding})`).join(' ')
      : 0};
`
export const WrapperSpecialTitle = styled.div<
  Pick<IContainerDescriptionProps, 'alignItems' | 'justifyContent'>
>`
  display: flex;
  height: calc(var(--cardWidth) / var(--aspectRatio));
  align-items: ${({ alignItems }) =>
    alignItems || ContainerDescriptionAlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || ContainerDescriptionJustifyContent.FlexStart};
`
